<template>
    <div v-if="esgResults">

        <b-container
            class="esg-iat-result__page-container mt-4"
        >
            <div class="mb-3 mb-lg-5">
                <img src="@/assets/ui/bq-logo-os-green.svg" height="40px" />
            </div>
            <div class="esg-iat-result__header mb-4">
                {{ $t('DASHBOARD_ESG_IAT_TITLE') }} 
            </div>
            <b-row>
                <b-col cols="12" lg="6" class="mb-5 pr-lg-5">
                    <div class="mb-4">
                        <span class="esg-iat-result__score-title">
                            {{ $t(`DASHBOARD_ESG_IAT_RESULT_TITLE_${esgResults.value}`) }} 
                        </span>
                    </div>

                    <div class="mb-4">
                        <div class="d-flex justify-content-between mb-3 mx-1">
                            <div >
                            {{ $t('DASHBOARD_ESG_IAT_RESULT_CHART_TITLE') }} 
                            </div>
                            <div class="esg-iat-result__score" >
                                {{ esgResults.value }}
                            </div>
                        </div>
                        <div class="mx-1">
                            <div class="mb-2">
                                <arrow-steps-center
                                    :value="this.result"
                                    :scale="this.maxScale" 
                                />
                            </div>
                            <div class="d-flex justify-content-between">
                               <div class="esg-iat-result__result-label">{{ $t('DASHBOARD_ESG_IAT_RESULT_CHART_LABEL_PERFORMANCE') }}</div>
                                <div class="esg-iat-result__result-label">{{ $t('DASHBOARD_ESG_IAT_RESULT_CHART_LABEL_SUSTAINABILITY') }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="esg-iat-result__score-description">
                        {{ $t(`DASHBOARD_ESG_IAT_RESULT_DESCRIPTION_${esgResults.value}`) }} 
                    </div>
                    <div>&nbsp;</div>
                    <div class="small">
                        <a target="_blank" :href="$t('DASHBOARD_ESG_IAT_RESULT_EXPLANATION_LINK')">{{ $t('DASHBOARD_ESG_IAT_RESULT_EXPLANATION') }}</a>
                    </div>
                </b-col>
                <b-col cols="12" lg="6" class="pl-lg-5 mb-5">
                    <div class="esg-iat-result__score-title mb-4">
                        <span v-html="$t('DASHBOARD_ESG_IAT_PERCENTILE_TITLE', { percentile: esgResults.percentile })"/> 
                    </div>
                    <div class="esg-iat-result__bell-curve-container">
                        <bell-curve-result
                            :value="esgResults.percentile"
                            :label="$t('DASHBOARD_ESG_IAT_PERCENTILE_YOU')"
                        />
                    </div>
                </b-col>
                <b-col cols="12" lg="6" class="mb-5 pr-lg-5">
                    <div class="esg-results__tips">
                        <div class="esg-iat-result__score-title mb-4">
                            {{ $t('DASHBOARD_ESG_IAT_TIPS_TITLE') }}
                        </div>
                        <div class="esg-results__tip esg-results__tip-border pb-3 mb-3">
                            <div class="esg-results__tip-title mb-1">
                                {{ $t('DASHBOARD_ESG_IAT_TIPS_1_TITLE') }}
                            </div>
                            <div class="esg-results__tip-description">
                                {{ $t('DASHBOARD_ESG_IAT_TIPS_1_DESCRIPTION') }}
                            </div>
                        </div>
                        <div class="esg-results__tip esg-results__tip-border pb-3 mb-3">
                            <div class="esg-results__tip-title mb-1">
                                {{ $t('DASHBOARD_ESG_IAT_TIPS_2_TITLE') }}
                            </div>
                            <div class="esg-results__tip-description">
                                {{ $t('DASHBOARD_ESG_IAT_TIPS_2_DESCRIPTION') }}
                            </div>
                        </div>
                        <div class="esg-results__tip pb-3 mb-3">
                            <div class="esg-results__tip-title mb-1">
                                {{ $t('DASHBOARD_ESG_IAT_TIPS_3_TITLE') }}
                            </div>
                            <div class="esg-results__tip-description">
                                {{ $t('DASHBOARD_ESG_IAT_TIPS_3_DESCRIPTION') }}    
                            </div>
                        </div>
                    </div>
                </b-col>
                <b-col cols="12" lg="6" class="mb-5 pl-lg-5">
                    <div class="esg-results__more-info mb-4">
                        <div class="esg-iat-result__score-title mb-4">
                            {{ $t('DASHBOARD_ESG_IAT_MORE_INFO_TITLE') }}
                        </div>
                        <div class="mb-5">
                            <b-button :href="$t('DASHBOARD_ESG_IAT_MORE_INFO_LINK')" target="_blank" variant="bq-green" block>
                                <span class="esg-results__more-info-button">
                                    {{ $t('DASHBOARD_ESG_IAT_MORE_INFO_BUTTON') }}
                                </span>
                            </b-button>
                        </div>
                        <div class="esg-results__more-info-screenshot mb-4">
                            <img width="100%" height="100%" src="@/assets/screen-bqp-comp.png"/>
                        </div>
                        <div class="esg-results__more-info-description">
                            {{ $t('DASHBOARD_ESG_IAT_MORE_INFO_DESCRIPTION') }}
                        </div>
                    </div>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { scaleValue } from '@/utils/calc'
import arrowStepsCenter from '@/components/vis/arrowStepsCenter'
import bellCurveResult from '@/components/vis/bellCurveResult'
import { TEXT_TYPES } from '@/constants/i18n'

export default {
    name: 'ESGResultsContainer',
    components: {
        arrowStepsCenter,
        bellCurveResult,
    },
    props: {
        interactionInstanceToken: {
            type: String
        }
    },
    data() {
        return {
            maxScale: 7,
            minScale: 1,
            sourceMinScale: -3,
            sourceMaxScale: 3,
        }
    },
    computed: {
        ...mapGetters([
            'esgResults'
        ]),
        result() {
            return this.esgResults && scaleValue(this.esgResults.value, this.sourceMaxScale, this.maxScale, this.sourceMinScale, this.minScale)
        }
    },
    methods: {
        ...mapActions([
            'fetchTranslations',
            'fetchESGResults',
            'setLoadingUntilResolved'
        ]),
        scaleValue
    },
    mounted() {
        this.setLoadingUntilResolved([
            this.fetchESGResults({ interactionInstanceToken: this.interactionInstanceToken }),
            this.fetchTranslations({
                textType: TEXT_TYPES.DASHBOARD, 
                filter: `DASHBOARD_ESG_IAT`
            }),
            this.fetchTranslations({
                textType: TEXT_TYPES.INTERACTION_BASE,
            }).then(() => document.title = this.$t(`${TEXT_TYPES.INTERACTION_BASE}_CUSTOMER_RESULTS_APPLICATION_TITLE_TEXT`))
        ])
    }
}
</script>
<style lang="scss">
.esg-iat-result__page-container {
    color: $main-font;
}

.esg-iat-result__bell-curve-container {
    width: 300px;
    margin: 0 auto;
    @media screen and (min-width: 576px) {
        width: 400px;
    }
}

.esg-iat-result__header {
    font-weight: bold;
    font-size: 1.5rem;
}

.esg-iat-result__score-title {
    font-weight: bold;
    font-size: 1.3rem;
    line-height: 1.2;
}

.esg-iat-result__score {
    color: $bq-green;
    font-weight: bold;
    font-size: 1.5rem;
}

.esg-iat-result__result-label {
    color: $bq-green;
    text-transform: uppercase;
    font-size: 0.9rem;
    font-weight: 600;
    letter-spacing: 0.5px;
}

.esg-results__tip-title {
    font-weight: 600;
    font-size: 1.125rem;
}

.esg-results__tip-border {
    border-bottom: 1px solid black;
}

.esg-iat-result__score-text {
    font-weight: bold;
}

.esg-results__more-info-button {
     font-weight: 600;   
}
</style>